import React from 'react';

import styled from '@emotion/styled';

import { IconProps } from '../../IconsProps';

const StyledSettings = styled.svg<IconProps>`
  .cls-1,
  .cls-2 {
    fill: none;
  }

  .cls-2 {
    stroke: var(--chatbot-color-primary, #404040);
    stroke-miterlimit: 10;
  }

  .cls-3 {
    fill: var(--du-color-white, #fff);
  }

  .cls-4 {
    fill: var(--chatbot-color-primary, #404040);
  }

  &.disabled {
    .cls-2 {
      stroke: var(--du-color-grey, #969696);
    }

    .cls-4 {
      fill: var(--du-color-grey, #969696);
    }
  }

  &:hover,
  &.active {
    &:not([disabled]) {
      .cls-2 {
        stroke: var(--du-color-primary, #128370);
      }

      .cls-4 {
        fill: var(--du-color-primary, #128370);
      }
    }
  }
`;

const AdminPortalIcon: React.FC<IconProps> = props => {
  const activeclass = props.active ? 'active' : undefined;
  return (
    <StyledSettings
      id='Settings-Icon'
      xmlns='http://www.w3.org/2000/svg'
      width='32'
      height='32'
      viewBox='0 0 32 32'
      className={activeclass}
    >
      <g id='AdminPortal_Icons' data-name='AdminPortal Icons' transform='translate(-105 -150)'>
        <path
          id='Union_11'
          data-name='Union 11'
          d='M-8022,909a8.009,8.009,0,0,1-8-8,8.009,8.009,0,0,1,8-8,8.01,8.01,0,0,1,7.938,7h-.848a7.187,7.187,0,0,0-7.091-6.157,7.164,7.164,0,0,0-7.155,7.156,7.119,7.119,0,0,0,1.92,4.863,5.339,5.339,0,0,1,5.235-4.319,5.3,5.3,0,0,1,3,.927v.971a4.561,4.561,0,0,0-3-1.131,3.854,3.854,0,0,0-1.06.126,4.706,4.706,0,0,0-3.49,4.083,7.161,7.161,0,0,0,4.55,1.64,7.086,7.086,0,0,0,3-.662v.917A7.937,7.937,0,0,1-8022,909Z'
          transform='translate(8143 -735)'
          fill='#969696'
          stroke='rgba(0,0,0,0)'
          strokeMiterlimit='10'
          strokeWidth='1'
          className='cls-4'
        />
        <g id='Icon' transform='translate(105 150)'>
          <rect id='Margin' width='32' height='32' fill='none' />
          <circle
            id='Ellipse_71'
            data-name='Ellipse 71'
            cx='7'
            cy='7'
            r='7'
            transform='translate(9 9)'
            fill='#e1e1e1'
            opacity='0'
            className='cls-4'
          />
          <path
            id='Path_8331'
            data-name='Path 8331'
            d='M16,15.733A2.53,2.53,0,1,1,18.53,13.2,2.532,2.532,0,0,1,16,15.733Zm0-4.426a1.9,1.9,0,1,0,1.9,1.9A1.9,1.9,0,0,0,16,11.307Z'
            fill='#969696'
            className='cls-4'
          />
        </g>
        <g id='Group_13916' data-name='Group 13916' transform='translate(114.514 149.601)'>
          <path
            id='Path_11501'
            data-name='Path 11501'
            d='M24.184,20.119a3.628,3.628,0,0,0-.049-.522l.944-.836-.828-1.433-1.2.407a3,3,0,0,0-.895-.522l-.248-1.234H20.251L20,17.212a3,3,0,0,0-.894.522l-1.2-.407-.828,1.433.944.836a2.739,2.739,0,0,0,0,1.044l-.944.837.828,1.432,1.2-.406a3.02,3.02,0,0,0,.894.522l.249,1.234h1.656l.248-1.234a3.013,3.013,0,0,0,.895-.522l1.2.406.828-1.432-.944-.837A3.628,3.628,0,0,0,24.184,20.119Zm-3.105,1.657a1.656,1.656,0,1,1,1.656-1.657A1.662,1.662,0,0,1,21.079,21.776Z'
            transform='translate(-7.321 0.422)'
            fill='none'
            stroke='#969696'
            strokeWidth='1'
          />
        </g>
      </g>
    </StyledSettings>
  );
};

export default AdminPortalIcon;
